// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"89":"component---src-templates-page-js","593":"framework","963":"fd6dec9c"}[chunkId] || chunkId) + "-" + {"89":"6ea8a6c72d6e6bde4fc7","113":"e1a96581d4be7d5200a5","593":"9673d49eecd38532f338","963":"512829fc259cc7e345d8"}[chunkId] + ".js";
};